import { combineReducers } from "redux";
import sectionReducer from './sections.js';
import lessonReducer from './lessons.js';
import userReducer from "./user.js";

const rootReducers = combineReducers({
    sections : sectionReducer,
    lessons : lessonReducer,
    users : userReducer,

})

export default rootReducers ;